import { FC, ReactNode } from 'react';

interface Props extends React.BaseHTMLAttributes<HTMLDivElement> {
  topic: string;
  children: ReactNode | ReactNode[];
  className?: string;
}

const ContentSection: FC<Props> = ({ topic, children, className = '' }) => {
  return (
    <section className={`Container flex flex-col ${className}`}>
      <h2 className="text-p2Medium text-darkBlue">{topic}</h2>

      <div className="text-p3Regular text-gray-600 mt-5 py-5">{children}</div>
    </section>
  );
};

export default ContentSection;
